import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { catchError, Observable } from 'rxjs';
import { DisplayType, PRODUCT_URL } from '../shared/src';
import { ErrorHandlerService } from './error-handler.service';
@Injectable({
    providedIn: 'root',
})
export class DisplayTypeService {
    private readonly DISPLAY_TYPE_API = `${PRODUCT_URL}/displayType`;

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    /**
 * Api for getAll DisplayType Info
 */
    public accountGetAll(
        pageIndex?: number,
        pageSize?: number,
        searchFilter?: string,
        status?: number
    ): Observable<any> {
        let queryParams = new HttpParams();
        // Only send search filter if it has at least 3 characters or is empty
        if (searchFilter && searchFilter.trim() && searchFilter.trim().length >= 3) {
            queryParams = queryParams.set('searchFilter', searchFilter.trim());
        }

        return this.http
            .get<any>(
                `${this.DISPLAY_TYPE_API}/getAll`,
                { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Sends a POST request to the server to add a new display type's information.
     * @param data - The display type data to be added
     * @returns
     */
    public addAccountDetails(data: {
        id: number;
        name: string;
        countryIds: number[];
    }): Observable<any> {
        console.log(data);

        return this.http
            .post<any>(`${this.DISPLAY_TYPE_API}/save`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Toggel status.
     * @param id - The unique identifier of the status
     */

    updateToggleAccountStatus(id: number): Observable<any> {
        return this.http
            .put<any>(`${this.DISPLAY_TYPE_API}/changeStatus/${id}`, null)
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Deletes a channel from the server.
     * @param id - The unique identifier of the channel to be deleted.
     * @returns An Observable that emits a confirmation message upon successful deletion.
     */
    public deleteAccount(id: number): Observable<string> {
        return this.http
            .delete<string>(`${this.DISPLAY_TYPE_API}/delete/${id}`)
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Deletes a display type from the server.
     * @param id - The unique identifier of the display type to be deleted.
     * @returns An Observable that emits a confirmation message upon successful deletion.
     */
    public deleteDisplayType(id: number): Observable<string> {
        return this.http
            .delete<string>(`${this.DISPLAY_TYPE_API}/delete/${id}`)
            .pipe(catchError(this.errorHandler.handleError));
    }

    // to get active channel status
    public getAllActiveAccount(searchFilter?: string): Observable<any> {
        let queryParams = new HttpParams();
        // Only send search filter if it has at least 3 characters or is empty
        if (searchFilter && searchFilter.trim() && searchFilter.trim().length >= 3) {
            queryParams = queryParams.set('searchFilter', searchFilter.trim());
        }
        return this.http
            .get<any>(`${this.DISPLAY_TYPE_API}/getAll`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * export accounts
     * @returns blob
     */
    public exportAccounts(): Observable<Blob> {
        const columns: string[] = ['Key DisplayType', 'Channel', 'Country']; //export needed columns
        // const columns:string[] = []; //export all columns

        return this.http
            .post<Blob>(
                `${this.DISPLAY_TYPE_API}/downloadExcelReport`,
                { columns },
                {
                    responseType: 'blob' as 'json',
                }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    // to get the dropdown for regions and country in text in excel
    public downloadExcelTemplate() {
        return this.http
            .get(`${this.DISPLAY_TYPE_API}/downloadExcelTemplate`, {
                responseType: 'blob',
            })
            .pipe(catchError(this.errorHandler.handleError));
    }
    /**
     * Updates DisplayType information on the server.
     * @param data - The DisplayType data to be updated.
     * @returns An Observable that emits the DisplayType.
     */
    public updateAccount(data: { id: number; name: string; countryIds: number[] }): Observable<any> {
        return this.http
            .post<any>(`${this.DISPLAY_TYPE_API}/update`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public importAccountData(data: any): Observable<DisplayType[]> {
        return this.http
            .post<DisplayType[]>(`${this.DISPLAY_TYPE_API}/importAccountData`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAccountByChannelId(countryId: number, channelId: number, searchFilter?: string): Observable<any> {
        let queryParams = new HttpParams();
        // Only send search filter if it has at least 3 characters or is empty
        if (searchFilter && searchFilter.trim() && searchFilter.trim().length >= 3) {
            queryParams = queryParams.set('searchFilter', searchFilter.trim());
        }
        if (countryId) {
            queryParams = queryParams.set('countryId', countryId);
        }
        if (channelId) {
            queryParams = queryParams.set('channelId', channelId);
        }
        return this.http.get<any>(`${this.DISPLAY_TYPE_API}/getAccountByChannelId`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAccountIdForPic(): Observable<any> {
        return this.http.get<any>(`${this.DISPLAY_TYPE_API}/getAccountidforPic`)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public updateToggleInvoiceRequired(id: number): Observable<any> {
        return this.http
            .put<any>(`${this.DISPLAY_TYPE_API}/changeInvoiceStatus/${id}`, null)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public updateToggleEnterPrice(id: number): Observable<any> {
        return this.http
            .put<any>(`${this.DISPLAY_TYPE_API}/changeEnterPriceStatus/${id}`, null)
            .pipe(catchError(this.errorHandler.handleError));
    }

}
